import type { TranslationFnc } from '~/_shared/utils/hooks';
import { MapSearchFilterBy } from '~/map/filter/mapSearchFilterBy.enum';

export const getMapSearchPlaceholder = (filterBy: MapSearchFilterBy | null, t: TranslationFnc) => {
  switch (filterBy) {
    case MapSearchFilterBy.OnlyGeolocated: {
      return t('Search in Google Location Matches only');
    }
    case MapSearchFilterBy.UserDataAndGeolocated: {
      return t('Search in Map Data & Google Location matches');
    }
    case MapSearchFilterBy.PlacesAndPoi:
      return t('placesTool.searchField.example');
    case MapSearchFilterBy.OnlyUserData:
    default: {
      return t('Search in Map Data only');
    }
  }
};
